// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"6d862595","173":"674d77fb","351":"ec6535ab"}[chunkId] + ".chunk.css";
};